import React, { useState } from 'react'
import { ToastContainer, toast } from "react-toastify";
import "./ForgotPassword.css";

interface ForgotPasswordPopupProps {
  onClose: () => void;
}

const ForgotPasswordPopup: React.FC<ForgotPasswordPopupProps> = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [emailError, setEmailError] = useState("");

  const CheckEmailExist = async (emailid: string) => {
    try {  
      const response = await fetch(process.env.REACT_APP_API_BASE_URL + "api/apiCallV1", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          mode: "emailexist",
          emailid: emailid,
        }),
      });
      const data = await response.json(); // ✅ Parse JSON response
      // console.log("Parsed Response Data:", data);  
      return data;
    } catch (error) {
      console.error("Error in CheckEmailExist:", error);
      throw error;
    }
  };

  const handleEmail = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL + "api/forgotpassword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          emailid: email.trim()
        }),
      });

      const data = await response.json();
      if (data?.header?.status == 200) {
        toast.success(data?.header?.message || "Your reset password link has been sent successfully to your email!", { autoClose: 3000 });
        setTimeout(() => {
          onClose();
        }, 3000);
      } else {
        toast.error(data?.header?.message || "Failed to send email. Please try again.", { autoClose: 3000 });
      }
    } catch (error) {
      // console.error("Error checking email:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const checkEmailAndHandle = async () => {
    if (!email.trim()) {  // ✅ Trim to prevent spaces being counted as input
      setEmailError("Email is required.");
      return;
    }  

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
      return;
    }
    setEmailError("");

    try {
      const response = await CheckEmailExist(email);

      if (response?.header?.status === 701) {
        // console.log("Email exists. Proceeding with email handling.");
        await handleEmail();
      } else {
        toast.error("Your email ID does not exist. Please enter a valid email.");
      }
    } catch (error) {
      // console.error("Error checking email:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      checkEmailAndHandle();
    }
  };

  return (
    <>
     <ToastContainer />
    <div style={{
      position: "fixed",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}>
      <div style={{
        background: "white",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        width: "90%",
        maxWidth: "350px",
        textAlign: "center",
        margin: "0 auto",
      }}>
        < div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <h2 style={{
            fontSize: "18px", margin: 0,
            lineHeight: "1", fontWeight: "bold"
          }}>
            Enter Your Registered Email
          </h2>
          <img
            src="/images/closeicon.svg"
            alt="Close"
            onClick={onClose}
            style={{
              cursor: "pointer",
              width: "10px",
              height: "10px",
            }}
          />
        </div>

        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          maxLength={100}
          onChange={(e) => {setEmail(e.target.value);
            setEmailError("");
          }}
          onKeyDown={handleKeyDown}
          style={{
            width: "95%",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            marginTop: "14px",
          }}
        />
        {emailError && <p className="email-error">{emailError}</p>}  {/* ✅ Show error message */}

        <button
          onClick={checkEmailAndHandle}
          style={{
            marginTop: "14px",
            background: "#21D6AA",
            color: "black",
            border: "none",
            padding: "10px 15px",
            borderRadius: "5px",
            cursor: "pointer",
            width: "35%",
          }}
        >
          Submit
        </button>
        {message && <p style={{ marginTop: "10px", color: "green", fontSize: "14px" }}>{message}</p>}
      </div>
    </div>
    </>
  )
}

export default ForgotPasswordPopup